export const userInitialData = {
  watchlater: [],
  history: [],
  likes: [],
};
